const FAQ = [
  {
    question: "How long does a typical bathroom remodel take?",
    answer:
      "Most bathroom remodels<IN_CITY_ZIP> take between 4 to 8 weeks once construction begins. Design, permitting, and material selections can extend the timeline depending on complexity.",
  },
  {
    question: "What’s the average cost of a bathroom remodel?",
    answer:
      "The average bathroom remodel<IN_CITY_ZIP> costs between $15,000 and $30,000, depending on square footage, layout changes, material choices, and plumbing upgrades. High-end remodels with luxury finishes can exceed $40,000.",
  },
  {
    question: "Do I need permits for a bathroom remodel?",
    answer:
      "Yes. Any bathroom remodel<IN_CITY_ZIP> involving plumbing, electrical, or structural work requires city permits. Modern Build manages the full permitting process to ensure code compliance and approval.",
  },
  {
    question: "Can I use my bathroom during the remodel?",
    answer:
      "Generally, no — the bathroom<IN_CITY_ZIP> will be unavailable during construction. We help you plan for temporary solutions and aim to minimize disruption throughout the project.",
  },
  {
    question: "Will you help with bathroom design and material selection?",
    answer:
      "Absolutely. Our designers<IN_CITY_ZIP> guide you through layout planning, tile selection, vanities, lighting, and finishes to ensure your bathroom reflects your style and budget.",
  },
  {
    question: "Do you offer financing for bathroom remodeling?",
    answer:
      "Yes. We offer financing options<IN_CITY_ZIP> including $0 down and flexible terms up to 15 years. Pre-approvals are fast and won’t impact your credit score.",
  },
  {
    question: "Why choose Modern Build for my bathroom remodel?",
    answer:
      "Modern Build delivers luxury bathroom remodels<IN_CITY_ZIP> with expert craftsmanship, clear communication, and tailored design. From permits to punch list, we manage every detail.",
  },
  {
    question: "Do you handle plumbing and electrical work?",
    answer:
      "Yes. All plumbing, electrical, and code-related work is performed by independent, licensed professionals from our trusted contractor network in <IN_CITY_ZIP>. We ensure every project is completed to California safety standards, fully inspected, and built to last.",
  },
  {
    question: "Can I remodel a small bathroom on a budget?",
    answer:
      "Yes. Small bathroom remodels<IN_CITY_ZIP> can be both stylish and cost-effective. We help prioritize layout improvements and smart material choices to deliver maximum value while staying within budget.",
  },
  {
    question: "What are the best materials for bathroom remodeling?",
    answer:
      "We recommend water-resistant materials<IN_CITY_ZIP> like porcelain tile, quartz countertops, and moisture-rated cabinetry. Our team helps select materials that balance performance, aesthetics, and budget.",
  },
  {
    question: "Do you offer 3D renderings or visual previews?",
    answer:
      "Yes. We can provide 3D renderings<IN_CITY_ZIP> for larger or custom bathroom remodels, helping you visualize layout and finish options before construction begins.",
  },
];

export default FAQ;
